import React, { useState, lazy, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import Box from '@material-ui/core/Box';
import { hasValue } from 'globalutils/fmUtils';
import { pageUrls } from 'globalconfig/constants/keys';
import { useParams } from 'react-router-dom';

import RenderComponent from './RenderComponent';

const layout = window?.$environment?.CURRENT_LAYOUT;

const Breadcrumb = lazy(() => import('globalcomponents/Breadcrumb'));
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const Index = ({ theme, filters, ...contentProps }) => (
  <Box style={{ ...theme.palette.contentStyle }}>
    <Breadcrumb filters={filters} />
    <Component {...contentProps} />
  </Box>
);

export default Index;

const Component = ({
  apiStatus,
  callback,
  history,
  Styled,
  postCustomDvirForm,
  i18n,
  customDvir,
  clearApiStatus
}) => {
  const match = useParams();
  const hasApiStatus = hasValue(apiStatus.status, 'api', postCustomDvirForm);
  const [initialValues, setInitialValues] = useState({
    name: '',
    description: '',
    pages: [],
    vehicles: []
  });

  const handleOnSubmit = (fields) => {
    const { vehicles, pages, ...finalRequest } = fields;

    const changedPages = pages.map((item) => {
      const { isEditing, key, isOpen, isTrailerSection, ...rest } = item;
      return {
        ...rest,
        isTrailerSection: true
      };
    });

    const vehicleIds = vehicles.map((item) => item.value);

    const payload = match.id
      ? {
        ...finalRequest,
        pages: changedPages,
        trailerIds: vehicleIds,
        unitType: 'TRAILER',
        id: match.id
      }
      : {
        ...finalRequest,
        pages: changedPages,
        unitType: 'TRAILER',
        trailerIds: vehicleIds
      };

    postCustomDvirForm({
      apiId: 'postCustomDvirForm',
      callback: {
        successCallback: () => {
          history.push(pageUrls.customDvirEnabled);
        },
        callback
      },
      data: payload
    });
  }

  useEffect(() => {
    const getVehicleList = () => {
      return (
        customDvir.vehicleList.length &&
        customDvir.currentItem.trailerIds?.map((source) => {
          return customDvir.vehicleList.find((e) => e.value === source);
        })
      );
    };

    const vehicleIdsList = getVehicleList() || [];

    setInitialValues({
      name: customDvir.currentItem.name || '',
      description: customDvir.currentItem.description || '',
      pages: customDvir.currentItem.pages || [],
      vehicles: [...vehicleIdsList]
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customDvir.vehicleList.length, customDvir.currentItem]);

  return (
    <Styled.Wrapper>
      <Form
        type="server"
        direction="column"
        initialValues={{ ...initialValues }}
        RenderComponent={RenderComponent}
        handleOnSubmit={handleOnSubmit}
        customProps={{
          hasApiStatus,
          clearApiStatus,
          setInitialValues,
          Styled,
          vehicleList: customDvir.vehicleList,
          formsList: customDvir.data,
          id: match.id,
          selectedVehicles: customDvir.currentItem.trailerIds || []
        }}
        validationSchema={Yup.object().shape({
          name: Yup.string().required(i18n.t('common.fieldRequiredMessage'))
        })}
      />
    </Styled.Wrapper>
  );
};

Component.propTypes = {
  history: PropTypes.object.isRequired,
  apiStatus: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired
};
